import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import css from './MobileActionBar.module.css';

/**
 * The full-width bottom action bar (P25009-443 BR-5/AC-2).
 *
 * A page's primary action on a phone is pinned here — Köp nu, Lägg in annons,
 * Skanna etikett — never crammed into the header, never hidden behind a
 * chevron, never scrolled away. One bar per page; the bar carries the action,
 * the drawer carries the navigation, and the two never compete (which is also
 * why this must not grow into a tab bar — the spec's scope section rules that
 * out explicitly: two fixed bars eat a fifth of the screen).
 *
 * Desktop renders nothing: there the primary action lives in the page header,
 * which has room for it.
 *
 * Usage:
 *   <MobileActionBar>
 *     <NamedLink className={mobileActionBarButtonPrimary} ...>+ Lägg in annons</NamedLink>
 *   </MobileActionBar>
 *
 * The component renders an in-flow spacer at its mount point (put it at the
 * end of the page content), so the fixed bar never sits on top of the last
 * rows of content.
 */
const MobileActionBar = ({ className, children }) => (
  <>
    <div className={css.spacer} aria-hidden="true" />
    <div className={classNames(css.root, className)}>{children}</div>
  </>
);

MobileActionBar.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};

/* Button skins for the bar's children, exported so hosts can put them on a
 * NamedLink, a <button> or an <a> alike. Primary is the accent colour — per
 * the status vocabulary green means done, never act. */
export const mobileActionBarButtonPrimary = css.primary;
export const mobileActionBarButtonSecondary = css.secondary;

export default MobileActionBar;
